<template>
  <div id="box-overlay">
    <template v-if="!isLoading">
      <div class="header-part">
        <div class="image-part">
          <img
            :src="
              `/static/icons/boxes/${$variables.boxTypes[box.type]}_box.svg`
            "
          />
        </div>
        <div class="info-part">
          <div class="title kaushan-font">{{ box.code }}</div>
          <div class="qr-wrapper">
            <div
              class="text"
              v-html="
                $t('storeScreen.boxItem.info.QRNumber', {
                  qrNumber: box.QRNumber
                })
              "
            ></div>
          </div>
          <div class="status-wrapper row">
            <div :class="`position-image type-${currentLocation}`"></div>
            <div class="position">
              {{ $t($variables.locationTypes[currentLocation]) }}
            </div>
          </div>
        </div>
      </div>
      <div class="content-part">
        <div class="movements-wrapper" v-if="movements.length > 0">
          <div class="movement" v-for="(item, index) in movements" :key="index">
            <boxes-movement-item :movement="item" />
          </div>
          <div class="show-more-button">
            <rounded-button
              :isOutline="true"
              class="button"
              position="center"
              v-if="hasMorePage"
              @click="showMore"
            >
              {{ $t("storeScreen.boxOverlay.showMore") }}
            </rounded-button>
          </div>
        </div>
        <template v-if="movements.length === 0">
          <div class="empty-state">
            <h5
              class="text"
              v-html="$t('storeScreen.boxOverlay.emptyState')"
            ></h5>
          </div>
        </template>
      </div>
    </template>
    <template v-if="isLoading">
      <div class="loading-screen">
        <div class="loading-screen">
          <loader-ring />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import BoxesMovementItem from "./BoxesMovementItem";
import { mapActions } from "vuex";
export default {
  name: "BoxOverlay",
  props: {
    box: {
      type: Object,
      required: true
    }
  },
  components: {
    BoxesMovementItem
  },
  data: () => ({
    isLoading: false,
    movements: [],
    response: undefined,
    currentPage: 1
  }),
  created() {
    this.isLoading = true;
    this.getMovements();
  },
  computed: {
    hasMorePage() {
      if (this.response) {
        return this.response.total > this.currentPage * this.response.per_page;
      } else {
        return false;
      }
    },
    currentLocation() {
      if (!this.box.current_position) {
        return 3;
      }
      const currentLocation = this.box.current_position;
      if (currentLocation.moved === 0) {
        return 0;
      } else if (currentLocation.moved === 1) {
        return 1;
      } else if (currentLocation.moved === 2) {
        return 2;
      }
      return 3;
    }
  },
  methods: {
    ...mapActions({
      readMovementsByBoxId: "movements/readMovementsByBoxId"
    }),
    showMore() {
      this.currentPage += 1;
      this.getMovements();
    },
    getMovements() {
      this.readMovementsByBoxId({
        boxID: this.box.box_id,
        page: this.currentPage
      })
        .then(res => {
          this.response = res.data;
          if (res.status === "OK") {
            if (this.movements.length === 0) {
              this.movements = res.data.data;
            } else {
              this.movements.push(...res.data.data);
            }
          }
          this.isLoading = false;
        })
        .catch(() => (this.isLoading = false));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#box-overlay {
  min-height: 100%;
  height: -webkit-fill-available;
  padding-top: 20px !important;
  padding: 10px;
  .loading-screen {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .empty-state {
    margin-top: 40px;
  }
  .header-part {
    height: 130px;
    display: flex;
    .image-part {
      margin-right: 20px;
      height: 100px;
      width: 100px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info-part {
      .title {
        text-align: center;
        font-size: 35px;
        font-weight: 550;
        margin-bottom: 5px;
      }
      .status-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 5px;
        .position {
          font-weight: 550;
          font-size: 15px;
        }
        .position-image {
          height: 15px;
          width: 15px;
          border-radius: 50%;
          margin-right: 5px;
          border: 1px solid $color-primary;
        }
      }
      .qr-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        .text {
          font-size: 15px;
          font-weight: 550;
        }
      }
    }
  }
  .content-part {
    padding-bottom: 20px;
    .show-more-button {
      margin-top: 40px;
    }
  }
}
</style>
